import { ReactNode } from "react";

export function formatCurrencyPipeText(value?: number, fixed: number = 0): string {
    if (!value) return "0";
    // Convert the number to a string and split it into integer and decimal parts
    const parts  = value.toFixed(fixed).split('.');
    // Add commas to the integer part
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const decimalPart = parts[1];

    // Combine the integer part, decimal part, and currency symbol
    return `${integerPart}${decimalPart?"."+decimalPart:""}`;
}

export function formatCurrencyPipe(value: number, fixed: number = 0): ReactNode {
    return <div className="text-right">{formatCurrencyPipeText(value, fixed)}</div>
}

export const currencyFormatter = (value?: string) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');